export default class Browsers {

	constructor() {
		if (vb.browser.getOSName() == 'iOS') {
			document.body.classList.add('ios');
		}

		if (vb.browser.getOSName() == 'Android') {
			document.body.classList.add('android');
		}
	}

}
